module.exports = __webpack_public_path__ + "img/B1.325f17bf.png";